import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface HighEstimateDialogProps {
  open: boolean
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  onClose: () => void
  onConfirm: () => void
}

const HighEstimateDialog = ({ open, checked, onCheckedChange, onClose, onConfirm }: HighEstimateDialogProps) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('worksheet.highEstimateConfirmationTitle')}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox
            checked={checked}
            onChange={(e) => onCheckedChange(e.target.checked)}
            aria-label="I confirm that I have explained the concept of HighEstimate"
          />
          <Typography>{t('worksheet.highEstimateConfirmationText')}</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="error">
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm} disabled={!checked} variant="contained" color="primary">
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default HighEstimateDialog
